import { render, staticRenderFns } from "./rankings.vue?vue&type=template&id=7bdf5774"
import script from "./rankings.vue?vue&type=script&lang=js"
export * from "./rankings.vue?vue&type=script&lang=js"
import style0 from "./rankings.vue?vue&type=style&index=0&id=7bdf5774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports